import React, { Component } from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import Layout from '../Layout';
import embeddings from '../assets/gensim_glove_vectors.zip';
import unigram from '../assets/unigrams_frequency.zip';
import bigram from '../assets/bigrams_frequency.zip';
import trigram from '../assets/trigrams_frequency.zip';
import tetragram from '../assets/tetragrams_frequency.zip';

export default class ResourceList extends Component {

  render() {
    return (
      <Layout>
        <div className="m-5">
          <h2>Resursai atsisiųsti</h2>
          <ListGroup>
            <ListGroupItem tag="a" href={embeddings} download="vectors.zip">
              <FontAwesomeIcon size="sm" icon={faDownload}/> Žodžių vektoriai (<i>embeddings</i>)
            </ListGroupItem>
            <ListGroupItem tag="a" href={unigram} download="1gram.zip">
              <FontAwesomeIcon size="sm" icon={faDownload}/> 1-gramos ir jų dažniai
            </ListGroupItem>
            <ListGroupItem tag="a" href={bigram} download="2gram.zip">
              <FontAwesomeIcon size="sm" icon={faDownload}/> 2-gramos ir jų dažniai
            </ListGroupItem>
            <ListGroupItem tag="a" href={trigram} download="3gram.zip">
              <FontAwesomeIcon size="sm" icon={faDownload}/> 3-gramos ir jų dažniai
            </ListGroupItem>
            <ListGroupItem tag="a" href={tetragram} download="4gram.zip">
              <FontAwesomeIcon size="sm" icon={faDownload}/> 4-gramos ir jų dažniai
            </ListGroupItem>
          </ListGroup>
        </div>

        <div className="m-5" id="konkordansai">
          <h2>Mokomojoje priemonėje (II dalyje) naudojami konkordansai</h2>
          <ListGroup>
            <ListGroupItem tag="a" href="/assets/konkordansai/ŠIRDIS_lietuviška grožinė literatūra.txt" download="ŠIRDIS_lietuviška grožinė literatūra.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> ŠIRDIS_lietuviška grožinė literatūra (3.10 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/ŠIRDIS_versta grožinė literatūra.txt" download="ŠIRDIS_versta grožinė literatūra.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> ŠIRDIS_versta grožinė literatūra (3.10 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/IDĖJA_lietuviški mokslo populiarinimo tekstai.txt" download="IDĖJA_lietuviški mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> IDĖJA_lietuviški mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/IDĖJA_versti mokslo populiarinimo tekstai.txt" download="IDĖJA_versti mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> IDĖJA_versti mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/ŠIRDIS_lietuviški mokslo populiarinimo tekstai.txt" download="ŠIRDIS_lietuviški mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> ŠIRDIS_lietuviški mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/ŠIRDIS_versti mokslo populiarinimo tekstai.txt" download="ŠIRDIS_versti mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> ŠIRDIS_versti mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/VILTIS_lietuviški mokslo populiarinimo tekstai.txt" download="VILTIS_lietuviški mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> VILTIS_lietuviški mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/VILTIS_versti mokslo populiarinimo tekstai.txt" download="VILTIS_versti mokslo populiarinimo tekstai.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> VILTIS_versti mokslo populiarinimo tekstai (3.11 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/IDĖJA_vertimas iš lietuvių į anglų.txt" download="IDĖJA_vertimas iš lietuvių į anglų.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> IDĖJA_vertimas iš lietuvių į anglų (4.4 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/ŠIRDIS_vertimas iš lietuvių į anglų.txt" download="ŠIRDIS_vertimas iš lietuvių į anglų.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> ŠIRDIS_vertimas iš lietuvių į anglų (4.4 užduotis)
            </ListGroupItem>
            <ListGroupItem tag="a" href="/assets/konkordansai/VILTIS_vertimas iš lietuvių į anglų.txt" download="VILTIS_vertimas iš lietuvių į anglų.txt">
              <FontAwesomeIcon size="sm" icon={faDownload}/> VILTIS_vertimas iš lietuvių į anglų (4.4 užduotis)
            </ListGroupItem>
          </ListGroup>
        </div>
      </Layout>
    );
  }
}
